<template>
  <f7-page class="bg-color-white">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-if-ios="material:menu" icon-if-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title>제주커머스 Mobile POS</f7-nav-title>
    </f7-navbar>

    <div class="main-menu">
      <div class="row">
        <div class="sale-mgmt" @click="goMenu('/sales/')">
          <img src="../assets/img_sales.png" style="width:70px; vertical-align:middle; margin-right:20px;" />
          판매관리
        </div>
      </div>
      <div class="row"></div>
      <div class="row">
        <div class="payment-list" @click="goMenu('/payment-list/')">
          <img src="../assets/img_payment_list.png" style="width:70px;" />
          <div class="label">결제내역조회</div>
        </div>
        <div class="settings" @click="goMenu('/settings/')">
          <img src="../assets/img_settings.png" style="width:70px;" />
          <div class="label">환경설정</div>
        </div>
      </div>
    </div>

    <div class="footer">
      Service Center &nbsp;064-702-0705<br />The True Leader - jejucommerce.com
    </div>
  </f7-page>
</template>

<script>
export default {
  methods: {
    goMenu(url) {
      //this.$f7router.navigate(url);
      this.$f7.views.main.router.navigate(url);
    }
  }
}
</script>
<style scoped>
.ios body, .md body { background-color:#fff; }

/* menu */
.main-menu { margin:50px auto; width:95%; display:table; text-align:center; }
.main-menu .row { display:table-row; width:100%; }
.main-menu .row:after { display:block; content:''; clear:both; margin-bottom:2.0%; }
.main-menu .row .sale-mgmt { width:100%; height:130px; display:table-cell; border:1px solid #ddd; vertical-align:middle; font-size:1.3em; text-align:left; padding-left:calc((48.2% - 75px) / 2); cursor:pointer; }
.main-menu .row .payment-list { width:48.2%; height:130px; display:table-cell; border:1px solid #ddd; vertical-align:middle; margin-right:3px; padding-top:20px; font-size:1.3em; float:left; cursor:pointer; }
.main-menu .row .settings { width:48.2%; height:130px; display:table-cell; border:1px solid #ddd; vertical-align:middle; margin-left:3px; padding-top:20px; font-size:1.3em; float:right; cursor:pointer; }
.main-menu .row .label { margin-top:3px; }
</style>


// WEBPACK FOOTER //
// src/pages/home.vue